export default {
    VIEW_APARTMENT: 'VIEW_APARTMENT',
    GET_BOOKING_BY_USER_ID: 'GET_BOOKING_BY_USER_ID',
    CLEAR_VIEWING_APARTMENT: 'CLEAR_VIEWING_APARTMENT',
    SET_BAD_CALENDAR_DAYS: 'SET_BAD_CALENDAR_DAYS',
    SET_GOOD_CALENDAR_DAYS: 'SET_GOOD_CALENDAR_DAYS',
    SET_TEMP_RESERVATION: 'SET_TEMP_RESERVATION',
    CLEAR_TEMP_RESERVATION: 'CLEAR_TEMP_RESERVATION',
};



// WEBPACK FOOTER //
// ./src/containers/ApartmentView/ApartmentViewConstants.js